import { EntityLinks, Goal } from '@griply/types';

import { isGoalArchived } from '../derived-goal-state';
import { isDerivedMetricId } from './derived-metric-ids';

export type IsGoalProgressUpdatableOptions = {
  goals: Goal[];
  links: EntityLinks;
};

export const isGoalProgressUpdatable = (
  goal: Goal,
  { goals, links }: IsGoalProgressUpdatableOptions,
): boolean =>
  !!goal.metric?.id &&
  !isDerivedMetricId(goal.metric.id) &&
  !goal.frozenAt &&
  !isGoalArchived(goal, goals, { links });
